'use client';

import { ErrorBoundary } from '@benzinga/core-ui';
import { NavigationFooter } from '@benzinga/navigation-ui';
import { FreestarPrivacyManager } from '@benzinga/ads';
import React from 'react';
import type { PageConfig } from '../page/pageConfig';

interface RootFooterProps {
  pageProps?: PageConfig;
}
const RootFooter = ({ pageProps }: RootFooterProps) => {
  return (
    <>
      {!pageProps?.headerProps?.hideFooter && (
        <ErrorBoundary name="footer">
          <NavigationFooter
            copyrightLinks={pageProps?.headerProps?.copyrightLinks}
            logoVariant={pageProps?.headerProps?.logoVariant}
            menu={pageProps?.headerProps?.footerMenu}
            showStickyFooter={pageProps?.headerProps?.showStickyFooter}
            variant={pageProps?.headerProps?.footerVariant}
          />
          <div className="mx-auto max-w-screen-xl px-4 pb-2 text-center text-sm">
            <FreestarPrivacyManager />
          </div>
        </ErrorBoundary>
      )}
    </>
  );
};

export default RootFooter;
